import { render, staticRenderFns } from "./EveryRewards.vue?vue&type=template&id=24822257&scoped=true&"
import script from "./EveryRewards.vue?vue&type=script&lang=js&"
export * from "./EveryRewards.vue?vue&type=script&lang=js&"
import style0 from "./EveryRewards.vue?vue&type=style&index=0&id=24822257&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24822257",
  null
  
)

export default component.exports